// Lightweight typo-tolerant matcher for client-side lists (assembly picker, etc.).
// Word-order-independent + partial-word + small edit-distance tolerance, so a slightly
// misspelled query ("combinr box") still matches ("Combiner Box 4-string").

const SPLIT = /[\s,/_\-().]+/;

function lev(a, b) {
  const m = a.length, n = b.length;
  if (!m) return n;
  if (!n) return m;
  let prev = new Array(n + 1);
  for (let j = 0; j <= n; j++) prev[j] = j;
  for (let i = 1; i <= m; i++) {
    let cur = [i];
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
    }
    prev = cur;
  }
  return prev[n];
}

// Does a query token match any word of the text (exact-substring or within a small typo budget)?
function tokenMatches(tok, words, hay) {
  if (hay.includes(tok)) return true;
  const tol = tok.length <= 4 ? 1 : 2;
  return words.some((w) => {
    if (w.includes(tok) || tok.includes(w)) return true;
    if (Math.abs(w.length - tok.length) > tol) return false;
    return lev(w, tok) <= tol;
  });
}

// Boolean filter: every query token must match somewhere in the text (fuzzily).
export function fuzzyIncludes(query, text) {
  const q = (query || "").toLowerCase().trim();
  if (!q) return true;
  const t = (text || "").toLowerCase();
  if (t.includes(q)) return true;
  const words = t.split(SPLIT).filter(Boolean);
  const qtokens = q.split(SPLIT).filter(Boolean);
  return qtokens.every((tok) => tokenMatches(tok, words, t));
}
